export interface EditorActionBarStoreType {
    /** Indicates whether the visibility settings menu is currently displayed for workspace editor. */
    isVisibilitySettingsMenuDisplayed: boolean

    visibilitySettingValues: VisibilitySettingsStates
    /** stores the actions available for the editor action bar */
    actions: EditorActionBarActions
    /** Tracks whether the store has finished hydrating from IndexedDB */
    _hasHydrated: boolean
}
export interface EditorActionBarActions {
    /**
     * Sets the display state of the visibility settings menu.
     */
    setIsVisibilitySettingsMenuDisplayed: (displayed: boolean) => void

    /**
     * Sets the state of for visibility settings selected values.
     */
    setVisibilitySettingValues: (value: VisibilitySettingsStates) => void

    /**
     * Syncs isInactiveContentVisible from old workspace's localStorage (read).
     */
    syncInactiveContentVisibilityFromLocalStorage: (params: {
        userId: string
        projectId: string
        elementId: string
        baseElementId: string
    }) => void

    /**
     * Syncs isInactiveContentVisible to old workspace's localStorage (write).
     */
    syncInactiveContentVisibilityToLocalStorage: (params: {
        userId: string
        projectId: string
        elementId: string
        baseElementId: string
        value: boolean
    }) => void
}
export interface VisibilitySettingsStates {
    areNotesVisible: boolean
    isInactiveContentVisible: boolean
    areTrackChangesVisible: boolean
}
export enum VisibilitySettingsActionType {
    NotesToSpecifier = 'Notes to Specifier',
    InactiveContent = 'Inactive Content',
    TrackChanges = 'Track Changes',
}
export interface ConfigItem {
    key: string
    actionLabel: string
    testId: string
}
